import React from "react";
import { BadgeCheck, ShieldCheck, Wallet } from "lucide-react";

const benefits = [
  { icon: BadgeCheck, title: "Egna certifierade takproffs", text: "Vi anlitar aldrig underleverantörer i smyg – samma team sköter hela jobbet, från kontroll till färdigt tak." },
  { icon: ShieldCheck, title: "10 års garanti", text: "På takmålning lämnar vi 10 års garanti i skrift. Vi står för vårt arbete." },
  { icon: Wallet, title: "Fri besiktning & fast pris", text: "Du får ett fast pris efter kostnadsfri kontroll – inga överraskningar och ROT-avdraget sköter vi åt dig." },
];

export default function Stats() {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Varför HPR</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">
            Ett nytt namn – med lång erfarenhet i teamet
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            HPR är ett nystartat takföretag, men våra takproffs har jobbat med tak i många år.
            Vi bygger på transparens: tydliga villkor, fasta priser och dokumenterat arbete – hela vägen.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {benefits.map((b) => (
            <div key={b.title} data-testid={`benefit-${b.title}`} className="reveal group rounded-2xl bg-[#f0f7ff] p-8 ring-1 ring-[#dbeafe] transition-all hover:bg-white hover:shadow-xl hover:shadow-[#1B45C4]/10 hover:-translate-y-1">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#1B45C4]/10">
                <b.icon className="w-6 h-6 text-[#1B45C4]" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-slate-900">{b.title}</h3>
              <p className="mt-2 text-slate-600 text-[15px]">{b.text}</p>
            </div>
          ))}
        </div>

        {/* Experience band – honest framing */}
        <div className="reveal mt-8 rounded-2xl hpr-gradient text-white p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center gap-6">
          <div className="sm:border-r sm:border-white/20 sm:pr-8">
            <p className="text-4xl sm:text-5xl font-extrabold font-display text-[#38BDF8]">2 600+</p>
            <p className="mt-1 text-sm font-semibold text-white/80">tak hanterade av vårt team</p>
          </div>
          <div>
            <p className="text-lg font-bold">Lång branscherfarenhet – nu under HPR</p>
            <p className="mt-1 text-white/75 max-w-xl">
              Siffran speglar den samlade erfarenheten hos våra takproffs genom åren. Nu samlar vi den
              kunskapen under HPR – med samma noggrannhet, men med tydligare dokumentation och garantier.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
